module.exports = __webpack_public_path__ + "assets/coaching.ed39c145.svg";